/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * HeartIcon
 */
export default class HeartIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M21.5 3.9c-2.5-2.5-6.6-2.5-9.2 0l-.3.4-.4-.4C9.1 1.4 5 1.4 2.4 3.9A6.42 6.42 0 00.5 8.5c0 1.7.7 3.4 1.9 4.6l8.9 8.9c.2.2.5.3.7.3.2 0 .5-.1.7-.3l8.9-8.9c2.5-2.6 2.5-6.7-.1-9.2zm-1.3 7.8L12 19.9l-8.2-8.2c-.9-.9-1.3-2-1.3-3.3 0-1.2.5-2.3 1.3-3.1C4.7 4.5 5.9 4 7 4c1.2 0 2.3.4 3.2 1.3l1.1 1.1c.2.2.5.3.7.3.3 0 .5-.1.7-.3l1-1c1.8-1.7 4.7-1.7 6.4 0 1.8 1.7 1.8 4.5.1 6.3z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

